import { Component, HostListener, Renderer2, RendererFactory2 } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { profile_access_module } from '@app/config/role-name.enum';
import { path_module_employer, path_module_public } from '@app/models/routes.name';
import { DataService } from '@app/services/data.service';
import { EmployerService } from '@app/services/employer.service';
import { ScriptService } from '@app/services/script.service';
import { UserService } from '@app/services/user.service';
import { status_code } from 'functions/src/help/status-query';
import { filter } from 'rxjs';

@Component({
  templateUrl: './layout-style-menu-lateral.component.html',
  styleUrls: ['./layout-style-menu-lateral.component.css'],
})
export class LayoutStyleMenuLateralComponent {

  public path_module_employer = path_module_employer;
  public path_module_public = path_module_public;
  public currentTs: number = 0;
  public statusManager: number = 1;
  private scrollPosition = 0;
  isSubmenuOpen: boolean = false;

  public profile_access_module = profile_access_module;
  @HostListener('window:resize')
  onResize(): void {
    this.scriptService.updateAllDynamicColWidths();
    this.scriptService.hideLateralMenubarTogglerControl();
  }

  private renderer: Renderer2;

  constructor(
    private router: Router,
    rendererFactory: RendererFactory2,
    private scriptService: ScriptService,
    public userService: UserService,
    private employerService: EmployerService,
    private dataService: DataService
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
    this.renderer.addClass(document.body, 'online-institution');
    this.renderer.addClass(document.body, 'internal-area');

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.currentTs = new Date().getTime();
    });

    this.dataService.sharedData.subscribe(data => {
      if (data.module === 'nav-manager-employer') {
        this.getStatusManager();
      }
    });

    this.getStatusManager();
  }

  onClickCloseMenu(event: MouseEvent) {
    event.preventDefault();
    this.scriptService.hideLateralMenubarTogglerControl()
  }

  onClickToogleMenu(event: MouseEvent) {
    event.preventDefault();

    const lateralMenu = document.querySelector('#lateral-menu-bar') as HTMLElement;

    const isCollapsed = lateralMenu.classList.contains('compact-mode');

    if (!isCollapsed) {
      this.saveScrollPosition();
    }



    this.scriptService.lateralMenubarTogglerControl();

    if (isCollapsed) {
      this.restoreScrollPosition();
    }
  }

  saveScrollPosition() {
    const sidebar = document.querySelector('#lateral-menu-content') as HTMLElement;
    this.scrollPosition = sidebar.scrollTop;
  }

  restoreScrollPosition(): void {
    setTimeout(() => {
      const sidebar = document.querySelector('#lateral-menu-content') as HTMLElement;
      sidebar.scrollTop = this.scrollPosition;
    }, 0);
  }

  ngAfterViewInit(): void {
    this.scriptService.updateAllDynamicColWidths();
    setTimeout(() => {
      this.scriptService.initPopover();
    }, 100);
  }

  getStatusManager() {

    if (!(+this.userService.getIdCurrentUser() > 0)) {
      this.statusManager = 1;
      return;
    }

    if (this.userService.isEmployer()) {


      this.employerService.getStatusManager(+this.userService.getIdCurrentUser()).toPromise().then(
        res => {
          if (res.status_code === status_code.success) {

        

            if (+this.userService.getUserEventFlag > 0 && res.is_valid_session === 0) {
              this.userService.saveEvent(this.userService.getIdCurrentUser(), 'logout', 'force').toPromise().then();
              this.router.navigate([path_module_public.logout]);
              return;
            }

            if (res.user_role) {
              this.userService.setLocalUserRole(res.user_role)
            }

            this.userService.setLocalAccessComplaintChannel(res.complaint_channel)

            if (+res.status_manager > 0) {
              this.statusManager = res.status_manager;
              this.dataService.nextSharedData({ module: 'onboarding-manager', value: this.statusManager });
              setTimeout(() => { this.scriptService.initPopover(); }, 100);
              return;
            }
            this.statusManager = 1;
            this.dataService.nextSharedData({ module: 'onboarding-manager', value: this.statusManager });
            setTimeout(() => { this.scriptService.initPopover(); }, 100);

            return;
          }
        }, () => {
          this.statusManager = 1;
          setTimeout(() => { this.scriptService.initPopover(); }, 100);
        }
      )

    }
    else if (this.userService.isAdminEmployer()) {


      this.employerService.getStatusManagerAdmin(+this.userService.getIdEmployer()).toPromise().then(
        res => {
          if (res.status_code === status_code.success) {

            this.userService.setLocalUserRole('admin')

            this.userService.setLocalAccessComplaintChannel(res.complaint_channel)

            if (+res.status_manager > 0) {
              this.statusManager = res.status_manager;
              this.dataService.nextSharedData({ module: 'onboarding-manager', value: this.statusManager });
              setTimeout(() => { this.scriptService.initPopover(); }, 100);
              return;
            }
            this.statusManager = 1;
            this.dataService.nextSharedData({ module: 'onboarding-manager', value: this.statusManager });
            setTimeout(() => { this.scriptService.initPopover(); }, 100);

            return;
          }
        }, () => {
          this.statusManager = 1;
          setTimeout(() => { this.scriptService.initPopover(); }, 100);
        }
      )

    }


  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'online-institution');
    this.renderer.removeClass(document.body, 'internal-area');
  }

  toggleSubmenu(event) {
    event.preventDefault();
    this.isSubmenuOpen = !this.isSubmenuOpen;
  }

}